import Client from "../baseClient";
import {
  PaymentRequest,
  PaymentSurcharge,
  PaymentResponse,
  CheckPaymentResponse,
  PayWithSavedCardRequest,
  PayWithSavedCardResponse,
} from "~/entities/paymentEntities";
import { AuthHeaders } from "~/api/endpoints/Auth";

export interface EstimateSurchargeRequest {
  paymentMethodId: string;
  tipAmount: number;
  orderPaymentAmount?: number;
}

export interface PayAtCounterResponse {
  orderNumber: string;
}

export const PaymentApi = {
  estimateSurcharge: async (
    orgId: string,
    siteId: string,
    orderId: string,
    payload: EstimateSurchargeRequest,
  ) =>
    await Client.post<PaymentSurcharge>(
      `${orgId}/${siteId}/orders/${orderId}/estimateSurcharge`,
      payload,
    ),

  beginPayment: async (
    authHeaders: AuthHeaders,
    subdomain: string,
    siteId: string,
    orderId: string,
    payload: PaymentRequest,
  ) =>
    await Client.post<PaymentResponse>(
      `org/${subdomain}/sites/${siteId}/orders/${orderId}/beginPayment`,
      payload,
      {
        headers: authHeaders,
      },
    ),

  payWithSavedCard: async (
    authHeaders: AuthHeaders,
    subdomain: string,
    siteId: string,
    orderId: string,
    payload: PayWithSavedCardRequest,
  ) =>
    await Client.post<PayWithSavedCardResponse>(
      `org/${subdomain}/sites/${siteId}/orders/${orderId}/payWithSavedCard`,
      payload,
      {
        headers: authHeaders,
      },
    ),

  payAtCounter: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    orderId: string,
  ) =>
    await Client.post<PayAtCounterResponse>(
      `${orgId}/${siteId}/orders/${orderId}/payAtCounter`,
      {},
      {
        headers: authHeaders,
      },
    ),
  checkPayment: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    orderId: string,
    paymentId: string,
  ) =>
    await Client.post<CheckPaymentResponse>(
      `${orgId}/${siteId}/orders/${orderId}/checkPayment/${paymentId}`,
      {},
      {
        headers: authHeaders,
      },
    ),
  saveCardForPayment: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    orderId: string,
    paymentId: string,
  ) =>
    await Client.post<CheckPaymentResponse>(
      `${orgId}/${siteId}/orders/${orderId}/saveCardForPayment/${paymentId}`,
      {},
      {
        headers: authHeaders,
      },
    ),
  cancelPayment: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    orderId: string,
    paymentId: string,
    force?: boolean,
  ) =>
    await Client.post<Response>(
      `${orgId}/${siteId}/orders/${orderId}/cancelPayment/${paymentId}`,
      { force },
      {
        headers: authHeaders,
      },
    ),
  noCharge: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    orderId: string,
    tableNumber?: string,
  ) =>
    await Client.post<PayAtCounterResponse>(
      `${orgId}/${siteId}/orders/${orderId}/noCharge`,
      { tableNumber },
      {
        headers: authHeaders,
      },
    ),
};
